<template>
  <section class="consulta-cidadaos">
    <!-- Filtros -->
    <b-card class="filters-card shadow-sm mb-4" body-class="p-4">
      <b-form @submit.prevent="onBuscar">
        <b-row>
          <b-col cols="12" md="7" class="mb-3 mb-md-0">
            <label class="form-label">
              Nome ou CPF <span class="text-danger">*</span>
            </label>
            <b-form-input
              v-model.trim="form.nomeCpf"
              :disabled="busy"
              :state="nomeCpfState"
              placeholder=""
            />
            <b-form-invalid-feedback v-if="nomeCpfState === false">
              Digite um CPF válido (11 dígitos) ou pelo menos duas palavras para
              o nome.
            </b-form-invalid-feedback>
          </b-col>

          <b-col cols="12" md="5">
            <label class="form-label">Data de nascimento</label>
            <b-form-input
              v-model.trim="form.dataNascimento"
              :disabled="busy"
              placeholder="dd/mm/aaaa"
              autocomplete="off"
              onfocus="(this.type='date')"
            />
          </b-col>
        </b-row>

        <div class="d-flex align-items-center justify-content-end mt-3">
          <b-button
            class="mr-3 btn-clear-filter"
            :disabled="
              busy || (form.nomeCpf === '' && form.dataNascimento === '')
            "
            @click="limparFiltros"
          >
            Limpar Filtros
          </b-button>

          <b-button type="submit" :disabled="busy" class="btn-submit-filter">
            <b-spinner small class="mr-2" v-if="busy" />
            <i class="icofont icofont-search-2 mr-2" v-else></i>
            Buscar Cidadão
          </b-button>
        </div>
      </b-form>
    </b-card>

    <!-- Header dos resultados + Exportar -->
    <div class="d-flex align-items-center mb-3">
      <h6 class="mb-0">Resultados da Busca ({{ rows }})</h6>
      <!-- <b-button
          variant="light"
          class="ml-auto shadow-sm"
          :disabled="!rows || busy"
          @click="$emit('exportar')"
        >
          <i class="icofont icofont-download mr-2"></i> Exportar
        </b-button> -->
    </div>

    <!-- Lista + overlay -->
    <b-overlay :show="busy" opacity="0.15" rounded="sm">
      <div v-if="rows" class="results-wrapper">
        <b-card
          v-for="(c, i) in pagedResults"
          :key="c.id || i"
          class="result-card mb-3"
          body-class="p-2"
        >
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 pr-3">
              <div class="result-name">
                {{ c.no_cidadao }} | <span>{{ c.sexo }}</span>
              </div>

              <b-row class="mt-1">
                <b-col cols="12" md="6" class="mb-2 mb-md-0">
                  <div class="kv">
                    <span class="k">CPF</span>
                    <span class="v">{{ formatCPF(c.nu_cpf) }}</span>
                  </div>
                  <div class="kv">
                    <span class="k">Data de nascimento</span>
                    <span class="v">{{ formatDate(c.dt_nascimento) }}</span>
                  </div>
                  <div class="kv">
                    <span class="k">Equipe responsável</span>
                    <span class="v">{{ c.no_equipe || '—' }}</span>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div class="kv">
                    <span class="k">Nome da mãe</span>
                    <span class="v">{{ c.no_mae || '—' }}</span>
                  </div>
                  <div class="kv">
                    <span class="k">UBS responsável</span>
                    <span class="v">{{ c.no_unidade_saude || '—' }}</span>
                  </div>
                  <div class="kv">
                    <span class="k">Microárea</span>
                    <span class="v">{{ c.micro_area || '—' }}</span>
                  </div>
                </b-col>
              </b-row>
            </div>

            <div class="result-actions text-nowrap">
              <b-button
                size="sm"
                class="btn-visualizar"
                :disabled="busy || isLoading(c, i)"
                @click="visualizar(c, i)"
              >
                <b-spinner small class="mr-2" v-if="isLoading(c, i)" />
                <i class="icofont icofont-search-2 mr-2" v-else></i>
                Visualizar
              </b-button>
            </div>
          </div>
        </b-card>

        <!-- Paginação -->
        <div
          class="d-flex flex-wrap align-items-center justify-content-between mt-3"
        >
          <div class="small text-muted mb-2 mb-sm-0">
            Mostrando {{ from }}–{{ to }} de {{ rows }}
          </div>

          <div class="d-flex align-items-center">
            <span class="mr-2 small text-muted">Por página</span>
            <b-form-select
              v-model="perPage"
              :options="perPageOptions"
              size="sm"
              class="mr-3"
            />
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="rows"
              size="sm"
              align="right"
              first-number
              last-number
            />
          </div>
        </div>
      </div>

      <!-- Vazio -->
      <div v-else class="empty-state text-center">
        <div class="empty-icon mx-auto">
          <i class="icofont icofont-search-document"></i>
        </div>
        <div class="empty-title">Nenhum cidadão encontrado</div>
        <p class="empty-desc">
          Para começar, utilize os filtros acima para fazer<br />
          uma busca. Verifique se os dados foram<br />
          digitados corretamente.
        </p>
      </div>
    </b-overlay>
  </section>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'ConsultaCidadaos',
  props: {
    resultados: { type: Array, default: () => [] },
    busy: { type: Boolean, default: false },
    autoOpen: { type: Boolean, default: false },
    modalId: { type: String, default: 'consulta-cidadaos-modal' },
    loadingId: { type: [String, Number, null], default: null },
  },
  mixins: [utils],
  data() {
    return {
      form: { nomeCpf: '', dataNascimento: '' },
      triedSubmit: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 50, 100],
    }
  },
  computed: {
    // valida: CPF (11 dígitos) OU pelo menos 2 palavras
    nomeCpfState() {
      if (!this.triedSubmit) return null
      return (
        this.isCpf(this.form.nomeCpf) || this.hasTwoWords(this.form.nomeCpf)
      )
    },
    rows() {
      return this.resultados?.length || 0
    },
    from() {
      if (!this.rows) return 0
      return (this.currentPage - 1) * this.perPage + 1
    },
    to() {
      if (!this.rows) return 0
      const t = this.currentPage * this.perPage
      return t > this.rows ? this.rows : t
    },
    pagedResults() {
      const start = (this.currentPage - 1) * this.perPage
      return this.resultados.slice(start, start + this.perPage)
    },
  },
  watch: {
    perPage() {
      this.currentPage = 1
    },
    resultados() {
      const maxPage = Math.max(1, Math.ceil(this.rows / this.perPage))
      if (this.currentPage > maxPage) this.currentPage = maxPage
    },
  },
  mounted() {
    if (this.autoOpen) this.$bvModal.show(this.modalId)
  },
  methods: {
    onBuscar() {
      this.triedSubmit = true
      if (
        !(this.isCpf(this.form.nomeCpf) || this.hasTwoWords(this.form.nomeCpf))
      ) {
        return
      }
      this.currentPage = 1
      this.$emit('buscar', { ...this.form })
    },

    limparFiltros() {
      this.form.nomeCpf = ''
      this.form.dataNascimento = ''
      this.triedSubmit = false
      this.currentPage = 1
      this.$emit('limpar')
    },

    isCpf(v = '') {
      const d = (v || '').replace(/\D/g, '')
      return d.length === 11
    },

    hasTwoWords(v = '') {
      const tokens = (v || '')
        .trim()
        .split(/\s+/)
        .filter((t) => t.length > 0)
      return tokens.length >= 2
    },

    formatCPF(v = '') {
      const d = (v || '').replace(/\D/g, '').slice(0, 11)
      return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') || '—'
    },

    keyFor(item, idx) {
      return item?.id ?? idx
    },

    isLoading(item, idx) {
      return (
        this.loadingId !== null && this.loadingId === this.keyFor(item, idx)
      )
    },

    visualizar(c, i) {
      const key = this.keyFor(c, i)
      this.$emit('visualizar', c, key)
      this.$bvModal.hide(this.modalId)
    },
  },
}
</script>

<style scoped lang="scss">
$muted: #6b7280;

.consulta-cidadaos {
  .title {
    font-weight: 800;
    font-size: 2rem;
    line-height: 1.2;
  }
  .subtitle {
    color: $muted;
  }
  .filters-card {
    border: 0;
    border-radius: 12px;
    .form-label {
      font-weight: 600;
    }
    .btn-clear-filter {
      text-transform: initial;
      background: none;
      color: #000;
      border: none;
      box-shadow: none;
      :disabled {
        background: grey;
        color: white;
      }
    }
    .btn-submit-filter {
      text-transform: initial;
      border-radius: 5px;
    }
  }

  .result-card {
    border: 1px solid #e6ebf2;
    border-radius: 10px;
    .result-name {
      font-weight: 700;
      color: #273146;
      span {
        font-weight: normal;
        font-size: 14px;
      }
    }
    .result-actions {
      display: flex;
      align-items: center;
      justify-content: center;

      .btn-visualizar {
        text-transform: initial;
        border-radius: 5px;
      }
    }
    .kv {
      font-size: 0.9rem;
      margin-bottom: 0.25rem;
      .k {
        color: #000;
        font-weight: 600;
        margin-right: 0.25rem;
      }
      .v {
        color: #111827;
      }
    }
  }

  .empty-state {
    padding: 48px 16px 64px;
    color: $muted;
    .empty-icon {
      width: 84px;
      height: 84px;
      border-radius: 50%;
      background: #eef2f7;
      display: grid;
      place-items: center;
      font-size: 32px;
    }
    .empty-title {
      font-weight: 700;
      color: #273146;
      margin-bottom: 6px;
    }
    .empty-desc {
      margin: 0;
      line-height: 1.6;
    }
  }
}
::v-deep .consulta-modal-dialog .modal-content {
  border: 0;
  border-radius: 14px;
}
</style>
